import React from "react";
import Button from "@material-ui/core/Button";
import Arrow from "../../../assets/Icons/arrow-form-small.png";

function StartScreen({ ...props }) {
  return (
    <div className="StepContainer FormWidth">
      <div className="FormTitleContainer">
        <p className="FormTitle">
          Looking for the best <br /> air freight solution?
        </p>
      </div>
      <div className="ContainerVertical MarginHorizontal">
        <Button
          style={{ marginTop: "1em" }}
          className="OldLace Medium"
          onClick={() => props.handleNext()}
        >
          Yes!
        </Button>
        <Button className="TransparentWhite Medium MarginHorizontal">
          More Info
        </Button>
        <img src={Arrow} alt="down-arrow" className="Padding" />
        <img src={Arrow} alt="down-arrow" className="Padding" />
        <img src={Arrow} alt="down-arrow" className="Padding" />
      </div>
    </div>
  );
}

export default StartScreen;
